<template>
  <header>
    <nav class="navbar navbar-dark bg-dark justify-content-between">
      <div class="container">
        <a class="navbar-brand" href="#" @click="goToDashboard()">
          <img src="@/assets/images/logo.svg" height="30" class="d-inline-block align-top" alt>
        </a>
        <div>
          <div class="btn-group profile-button" :style="{opacity: profileLoading ? 0 : 1}">
            <button type="button" class="btn">
              <img class="profile-icon" src="@/assets/images/default_profile_icon.jpg">
              <span class="mobile">{{name}}</span>
            </button>
          </div>
        </div>
      </div>
    </nav>
  </header>
</template>

<script>
import axios from "axios";
import config from "@/config/config";
export default {
  name: "Navbar",
  data() {
    return {
      name: "Gevme User",
      avatar_hash: "",
      profileLoading: false,
      clicked_data: "clicked"
    };
  },
  methods: {
    homeClicked() {
      Event.$emit("Home clicked", this.clicked_data);
    },
    goToDashboard() {
      this.$router.push({
        name: "Dashboard",
        params: {
          deleted: false
        }
      });
    }
  },
  computed: {
    avatar_url() {
      return `${config.gevmeUrl}users/avatar/${this.avatar_hash}.jpg`;
    }
  },
  mounted() {
    axios
      .post(
        window.ENDPOINT,
        {
          query: `
                  query {
                    me
                  }
                `,
          variables: null
        },
        {
          headers: {
            Authorization: localStorage.getItem("gevme_token")
          }
        }
      )
      .then(
        async function(response) {
          this.name = `${response.data.data.me.firstname} ${
            response.data.data.me.lastname
          }`;
          this.avatar_hash = response.data.data.me.avatar_hash;
          this.profileLoading = false;
        }.bind(this)
      );
  }
};
</script>

<style scoped>
.profile-icon {
  width: 40px;
  height: 40px;
  margin-right: 10px;
  border-radius: 50%;
}

.btn.profile {
  pointer-events: none;
}

@media screen and (max-width: 991px) {
  .mobile {
    display: none;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue